import EnrollCompleteSvg from "@/assets/enrollment-complete.svg?react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const EnrollmentComplete = () => {
  return (
    <div className="mt-24 flex flex-col items-center gap-4 text-center">
      <EnrollCompleteSvg className="mx-auto" />
      <p>
        Haz completado el registro a una nueva edición de manera correcta.
        Revisaremos los documentos enviados y cuando estos sean aprobados,
        recibirás un correo de confirmación.
      </p>
      <p>
        <strong>¡Gracias por tu inscripción!</strong>
      </p>
      <Button className="mt-8" asChild>
        <Link to="/">Volver al Home</Link>
      </Button>
    </div>
  );
};

export default EnrollmentComplete;
